/**
 * Ticket data API · split-bundle architecture (Phase 7 follow-on).
 *
 * - Sync API (ticketById/ticketsBySprint/allTickets) returns `TicketMeta` —
 *   eager metadata only · ~50 KB gzip in main bundle. Used by Dashboard /
 *   Sprint / App for immediate render.
 * - Async API (loadTicketBody) dynamically imports the right `_bodies/sprint-XX.ts`
 *   chunk · used by Ticket.tsx after the user opens a specific ticket.
 *
 * The full ticket bodies (~1 MB raw) ride per-sprint chunks loaded on demand.
 *
 * Truth source for content authoring: `sprint-01..06.ts` files (full Ticket
 * arrays). After editing any of them, re-run `npx vite-node scripts/split-tickets.ts`
 * to regenerate `_meta.ts` and `_bodies/sprint-XX.ts`.
 */
import type { TicketMeta } from '@shared/schemas';
import { TICKET_META } from './_meta';

export { TICKET_META } from './_meta';

const META_BY_ID = new Map<string, TicketMeta>(TICKET_META.map((t) => [t.id, t]));

export const ticketById = (id: string): TicketMeta | undefined => META_BY_ID.get(id);

export const ticketsBySprint = (sprintId: string): TicketMeta[] =>
  TICKET_META.filter((t) => t.sprintId === sprintId).slice().sort((a, b) => a.ord - b.ord);

export const allTickets = (): TicketMeta[] => [...TICKET_META];

// --- Ticket BODIES are NOT loaded here (slot_content_protection · 29 JUN) ---
// The per-sprint dynamic body imports moved to `./bodies.ts` so this metadata
// module (imported by the CLIENT) carries NO `_bodies` chunk — course content is
// no longer a public CDN asset. Bodies are served only by the gated edge `content`
// function (imports ./bodies.ts). The CLIENT fetches bodies from /api/content/...
// via src/data/ticketBody.ts.
